"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
var color_string_1 = require("../vendor/color-string");
var STRING = 'string';
var OBJECT = 'object';
function parseString(str) {
    if (!str) {
        return null;
    }
    if (typeof str === OBJECT || (typeof str === STRING && str.trim().slice(0, 3) === 'url')) {
        return str;
    }
    return color_string_1.get(String(str));
}
function generateString(desc) {
    if (typeof desc === STRING) {
        return desc;
    }
    if (!desc) {
        return 'none';
    }
    return color_string_1.to(desc.model, desc.value);
}
exports.default = {
    parseString: parseString,
    generateString: generateString,
};
//# sourceMappingURL=ColorUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/ColorUtils.js
// module id = 120
// module chunks = 35783957827783 127651196306611 162898551421021